<template>
  <div class="container">
    <div style="width: 100%; margin: 0 auto">
      <el-card class="box-card" style="margin-top: 95px; margin-bottom: 95px">
        <el-form ref="form" :model="form" label-width="80px">
          <el-row>
            <el-form-item label="小区名称" class="re-2">
              <el-input
                v-model="form.xqname"
                placeholder="请输入小区名称"
              ></el-input>
            </el-form-item>
          </el-row>

          <el-row>
            <el-col :span="8">
              <el-form-item label="楼号(几楼)" class="re-11">
                <el-input
                  v-model="form.lounumber"
                  placeholder="小区几楼"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="楼号(几号)" class="re-11">
                <el-input
                  v-model="form.haonumber"
                  placeholder="小区几号"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8">
              <el-form-item label="房源户型" class="re-4">
                <el-select
                  v-model="form.regionRoom"
                  class="re-3"
                  placeholder="室"
                >
                  <el-option label="1室" value="1"></el-option>
                  <el-option label="2室" value="2"></el-option>
                  <el-option label="3室" value="3"></el-option>
                  <el-option label="4室" value="4"></el-option>
                  <el-option label="5室" value="5"></el-option>
                  <el-option label="6室" value="6"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="" class="re-5">
                <el-select
                  v-model="form.regionTing"
                  class="re-3"
                  placeholder="厅"
                >
                  <el-option label="0厅" value="0"></el-option>
                  <el-option label="1厅" value="1"></el-option>
                  <el-option label="2厅" value="2"></el-option>
                  <el-option label="3厅" value="3"></el-option>
                  <el-option label="4厅" value="4"></el-option>
                  <el-option label="5厅" value="5"></el-option>
                  <el-option label="6厅" value="6"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="" class="re-6">
                <el-select
                  v-model="form.regionWei"
                  class="re-3"
                  placeholder="卫"
                >
                  <el-option label="1卫" value="1"></el-option>
                  <el-option label="2卫" value="2"></el-option>
                  <el-option label="3卫" value="3"></el-option>
                  <el-option label="4卫" value="4"></el-option>
                  <el-option label="5卫" value="5"></el-option>
                  <el-option label="6卫" value="6"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="付款方式" class="re-7">
                <el-select
                  v-model="form.regionYajing"
                  class="re-3"
                  placeholder="请选择"
                >
                  <el-option label="押一" value="押一"></el-option>
                  <el-option label="押二" value="押二"></el-option>
                  <el-option label="押三" value="押三"></el-option>
                  <el-option label="押四" value="押四"></el-option>
                  <el-option label="押五" value="押五"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="" class="re-8">
                <el-select
                  v-model="form.regionZujing"
                  class="re-3"
                  placeholder="请选择"
                >
                  <el-option label="付一" value="付一"></el-option>
                  <el-option label="付二" value="付二"></el-option>
                  <el-option label="付三" value="付三"></el-option>
                  <el-option label="付四" value="付四"></el-option>
                  <el-option label="付五" value="付五"></el-option>
                  <el-option label="半年付" value="半年付"></el-option>
                  <el-option label="一年付" value="一年付"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="租赁类型" class="re-7">
                <el-select
                  v-model="form.rentType"
                  class="re-3"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, key) in form.rentTypeList"
                    :label="item"
                    v-bind:key="key"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="房源类型:" class="re-9">
            <el-row :gutter="168">
              <el-radio-group v-model="form.radioHouseType" class="re-10">
                <el-col
                  :span="4"
                  v-for="(item, key) in form.radioHouseTypeList"
                  v-bind:key="key"
                >
                  <el-radio :label="item.id">{{ item.name }}</el-radio>
                </el-col>
              </el-radio-group>
            </el-row>
          </el-form-item>
          <el-row>
            <el-col :span="8">
              <el-form-item label="所在区域" class="re-7">
                <el-cascader
                  ref="cascader"
                  v-model="form.quyu"
                  placeholder="试试搜索"
                  :options="form.quyuList"
                  size="medium"
                  filterable
                  @change="handleChange"
                ></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-col :span="8">
              <el-form-item label="所在区域" class="re-7">
                <el-select
                  v-model="form.quyu"
                  class="re-3"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, key) in form.quyuList"
                    :label="item.name"
                    v-bind:key="key"
                    :value="item.areaid"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row> -->
          <!-- <el-row>
            <el-col :span="8">
              <el-form-item label="地铁线" class="re-7">
                <el-select
                  v-model="form.subway"
                  class="re-3"
                  placeholder="请选择"
                >
                  <el-option label="1号线" value="1"></el-option>
                  <el-option label="2号线" value="2"></el-option>
                  <el-option label="3号线" value="3"></el-option>
                  <el-option label="4号线" value="4"></el-option>
                  <el-option label="5号线" value="5"></el-option>
                  <el-option label="6号线" value="6"></el-option>
                  <el-option label="7号线" value="7"></el-option>
                  <el-option label="8号线" value="8"></el-option>
                  <el-option label="9号线" value="9"></el-option>
                  <el-option label="10号线" value="10"></el-option>
                  <el-option label="11号线" value="11"></el-option>
                  <el-option label="12号线" value="12"></el-option>
                  <el-option label="13号线" value="13"></el-option>
                  <el-option label="16号线" value="16"></el-option>
                  <el-option label="17号线" value="17"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row v-if="options.length > 0">
            <!-- <el-form-item label="地铁站点" class="re-12">
              <el-input
                v-model="form.subwaystation"
                placeholder="请输入地铁站点"
              ></el-input>
            </el-form-item> -->
            <el-col :span="8">
              <el-form-item label="地铁站点" class="re-7">
                <el-cascader
                  v-model="form.lineStation"
                  placeholder="试试搜索"
                  :options="options"
                  filterable
                ></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="面积" class="re-12">
              <el-input
                v-model="form.housesize"
                type="number"
                placeholder="平方米"
              ></el-input>
            </el-form-item>
          </el-row>
          <!-- <el-row>
            <el-form-item label="详细地址" class="re-2">
              <el-input
                v-model="form.address"
                placeholder="请输入详细地址"
              ></el-input>
            </el-form-item>
          </el-row> -->
          <el-row>
            <el-col :span="8">
              <el-form-item label="房屋租金" class="re-11">
                <el-input
                  v-model="form.rent"
                  type="number"
                  placeholder="元"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="佣金比例" class="re-11">
                <el-input
                  v-model="form.rentbai"
                  type="number"
                  placeholder="百分比"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="房屋设施:" class="re-9">
            <el-row :gutter="128">
              <el-checkbox-group v-model="form.sheshi" class="re-10">
                <el-col
                  :span="4"
                  v-for="(item, key) in form.sheshiList"
                  v-bind:key="key"
                >
                  <el-checkbox :label="item.id" name="type">{{
                    item.name
                  }}</el-checkbox>
                </el-col>
              </el-checkbox-group>
            </el-row>
          </el-form-item>

          <el-row>
            <div
              class="el-form-item__label"
              style="margin-left: 10px; margin-bottom: 5px"
            >
              简介:
            </div>
            <el-form-item label="" class="re-2copy">
              <el-input
                type="textarea"
                :rows="7"
                placeholder="关于该房屋的其它信息"
                v-model="form.jianjie"
              ></el-input>
            </el-form-item>
          </el-row>

          <el-row>
            <!-- <el-form-item label="重新上传图片:" class="re-13"></el-form-item> -->
            <div
              class="el-form-item__label"
              style="margin-left: 10px; margin-bottom: 5px"
            >
              重新上传图片:
            </div>
          </el-row>
          <el-row>
            <el-form-item label="" class="re-14">
              <el-upload
                action="test"
                ref="upload"
                list-type="picture-card"
                name="UploadForm[file][]"
                :multiple="true"
                :limit="20"
                accept=".jpg, .jpeg, .png, .gif, .bmp"
                :auto-upload="false"
                :http-request="handleUpload"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-row>
          <el-row>
            <el-button type="primary" round @click="submitUpload" class="sdf"
              >上传</el-button
            >
          </el-row>
        </el-form>
      </el-card>
    </div>
  </div>
</template>
<script>
import https from "../http.js";
import qs from "qs";
export default {
  data() {
    return {
      form: {
        fileList: [],
        xqname: "",
        lounumber: "",
        haonumber: "",
        regionRoom: "",
        regionTing: "",
        regionWei: "",
        regionYajing: "",
        regionZujing: "",
        radioHouseType: "",
        // address: "",
        rent: "",
        quyu: [],
        rentbai: "",
        sheshi: [],
        // subway: "",
        // subwaystation: "",
        lineStation: [],
        imgurldata: "",
        quyuList: [],
        radioHouseTypeList: [],
        sheshiList: [],
        jianjie: "",
        fangdxingming: "",
        fangdphone: "",
        housesize: "",
        rentType: "",
        rentTypeList: ["长租", "短租"],
        area: "",
        province: "",
        city: "",
        regional: "",
        location_address: "",
        longitude: "",
        latitude: "",
      },
      files: [],
      options: [],
    };
  },

  created: function() {
    https
      .fetchPost("/releases-house/releases-house")
      .then((data) => {
        this.form.quyuList = data.data.province;
        this.form.radioHouseTypeList = data.data.house_type;
        this.form.sheshiList = data.data.facilitise;
        // this.options = data.data.line_station;
      })
      .catch((err) => {
        console.log(err);
      });

    var houseid = this.$route.query.house_id;
    var param = {
      house_id: houseid,
    };
    //alert(this.$route.query.house_id)
    https
      .fetchPost("/personal-center/house-update", qs.stringify(param))
      .then((data) => {
        this.form.xqname = data.data.house_data.village_name;
        this.form.lounumber = data.data.house_data.building_no;
        this.form.haonumber = data.data.house_data.room_no;
        this.form.regionRoom = data.data.house_data.room;
        this.form.regionTing = data.data.house_data.hall;
        this.form.regionWei = data.data.house_data.bathrooms;
        this.form.regionYajing = data.data.house_data.and;
        this.form.fangdxingming = data.data.house_data.landlord_name;
        this.form.fangdphone = data.data.house_data.landlord_phone;
        this.form.housesize = data.data.house_data.size;
        this.form.regionZujing = data.data.house_data.pay;
        this.form.radioHouseType = data.data.house_data.type_id;
        // this.form.quyu = data.data.house_data.area;
        // this.form.subway = data.data.house_data.subway;
        // this.form.subwaystation = data.data.house_data.station;
        this.form.lineStation.push(data.data.house_data.subway + "号线");
        this.form.lineStation.push(data.data.house_data.station);
        this.form.quyu.push(data.data.house_data.province);
        this.form.quyu.push(data.data.house_data.city);
        this.form.quyu.push(data.data.house_data.regional);
        // this.form.address = data.data.house_data.address;
        this.form.jianjie = data.data.house_data.introduction;
        this.form.rent = data.data.house_data.rental;
        this.form.rentbai = data.data.house_data.commission;
        var sheshiform = data.data.house_data.facilities;
        var sheshishuzu = sheshiform.split(",");
        this.form.sheshi = sheshishuzu;
        this.form.rentType = data.data.house_data.rent_type;
        this.form.province = data.data.house_data.province;
        this.form.city = data.data.house_data.city;
        this.form.regional = data.data.house_data.regional;
        this.form.area = data.data.house_data.area;
        this.form.location_address = data.data.house_data.location_address;
        this.form.latitude = data.data.house_data.latitude;
        this.form.longitude = data.data.house_data.longitude;

        var urlStr = data.data.house_data.imgurl;
        this.getLineStation();
      })
      .catch((err) => {
        console.log(err);
      });
  },

  methods: {
    handleChange(value) {
      let nodesInfo = this.$refs["cascader"].getCheckedNodes();
      this.form.latitude = "";
      this.form.longitude = "";
      this.form.location_address = value[0] + value[1] + value[2];
      this.form.area = nodesInfo[0].data.areaid;
      // console.log(this.form.area);
      this.form.province = value[0];
      this.form.city = value[1];
      this.form.regional = value[2];

      console.log(this.form.city);
      this.getLineStation();
    },

    getLineStation() {
      var param = {
        city: this.form.city,
      };
      https
        .fetchPost("/wechat-index/get-line-station", qs.stringify(param))
        .then((res) => {
          this.options = res.data.data;
          if (res.data.data.length == 0) {
            this.form.lineStation = [null, null];
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    onSubmit() {
      console.log("submit!");
    },

    handleUpload(raw) {
      this.files.push(raw.file);
    },

    async submitUpload() {
      var xqnamed = this.form.xqname;
      var lounumberd = this.form.lounumber;
      var haonumberd = this.form.haonumber;
      var regionRoomd = this.form.regionRoom;
      var regionTingd = this.form.regionTing;
      var regionWeid = this.form.regionWei;
      var regionYajingd = this.form.regionYajing;
      var regionZujingd = this.form.regionZujing;
      var radioHouseTyped = this.form.radioHouseType;
      var province = this.form.quyu[0];
      var city = this.form.quyu[1];
      var regional = this.form.quyu[2];
      // var quyud = this.form.quyu;
      // var subwayd = this.form.subway;
      // var subwaystationd = this.form.subwaystation;
      var subwayd = this.form.lineStation[0];
      var subwaystationd = this.form.lineStation[1];
      // var addressd = this.form.address;
      var rentd = this.form.rent;
      var rentbaid = this.form.rentbai;
      var jianjied = this.form.jianjie;
      var housesized = this.form.housesize;
      var sheshid = this.form.sheshi;
      var fdname = this.form.fangdxingming;
      var fdphone = this.form.fangdphone;
      var imgurlend = this.form.imgurldata;
      var rentType = this.form.rentType;
      // var userid = sessionStorage.getItem("userid");
      var userid = this.$cookies.get("userid");
      if (!userid) {
        this.$alert("前往登录？", "登陆已过期，请重新登陆", {
          confirmButtonText: "确定",
          callback: (action) => {
            if (action == "cancel") {
              this.$router.push({ path: "/index" });
            } else {
              this.$router.push({ path: "/login" });
            }
          },
        });
        // this.$message.error("登陆已过期，请重新登陆");
        // this.$router.push({ path: "/login" });
        return false;
      }
      var sheshidstring = sheshid.join(",");
      // var hhjq = imgurlend.join();

      //console.log(param)
      // console.log(sheshidstring)

      if (xqnamed == "") {
        this.$message.error("请填写小区名称");
        return false;
      }

      if (lounumberd == "") {
        this.$message.error("请填写小区楼号（几楼）");
        return false;
      }

      if (haonumberd == "") {
        this.$message.error("请填写小区楼号（几号）");
        return false;
      }

      if (regionRoomd == "") {
        this.$message.error("请选择户型(室)");
        return false;
      }

      if (regionTingd == "") {
        this.$message.error("请选择户型(厅)");
        return false;
      }

      if (regionWeid == "") {
        this.$message.error("请选择户型(卫)");
        return false;
      }

      if (regionYajingd == "") {
        this.$message.error("请选择付款方式（押金）");
        return false;
      }

      if (regionZujingd == "") {
        this.$message.error("请选择付款方式（租金）");
        return false;
      }

      if (radioHouseTyped == "") {
        this.$message.error("请选择房源类型");
        return false;
      }

      if (province == "" || city == "" || regional == "") {
        this.$message.error("请选择所在区域");
        return false;
      }

      if (this.options.length > 0 && (subwayd == "" || subwayd == undefined)) {
        this.$message.error("请选择地铁线");
        return false;
      }

      if (
        this.options.length > 0 &&
        (subwaystationd == "" || subwaystationd == undefined)
      ) {
        this.$message.error("请填写地铁站点");
        return false;
      }

      if (housesized == "") {
        this.$message.error("请输入面积（平方米）");
        return false;
      }

      if (rentd == "") {
        this.$message.error("请填写房屋租金");
        return false;
      }

      if (rentbaid == "") {
        this.$message.error("请填写佣金比例");
        return false;
      }

      if (sheshid.length == 0) {
        this.$message.error("请选择房屋设施");
        return false;
      }

      // if (this.file == "") {
      //   this.$message.error("请选择上传图片");
      //   return false;
      // }

      const loading = this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      this.$refs.upload.submit(); // 这里是执行文件上传的函数，其实也就是获取我们要上传的文件
      let fd = new FormData();

      this.files.forEach(function(file) {
        console.log(file);
        fd.append("UploadForm[file][]", file, file.name); // 因为要上传多个文件，所以需要遍历一下才行
        //不要直接使用我们的文件数组进行上传，你会发现传给后台的是两个Object
      });

      await https
        .fetchPost("/personal-center/upload", fd, {
          headers: {
            "Content-type": "multipart/form-data",
          },
        })
        .then((data) => {
          var imgdata = data.data.img;
          var imgdatad = imgdata.join(",");

          // console.log(imgdatad)

          imgurlend = imgdatad;
          // console.log(data.data.img);
        })
        .catch((err) => {
          console.log(err);
        });

      // console.log(this.form.imgurldata);

      //console.log(this.form.imgurldata.length);
      // await  this.$refs.upload.submit();
      //  param.imgurl = param.imgurl.join();

      // console.log(param.imgurl)
      //this.form.imgurldata = Array.from(this.form.imgurldata)
      var houseid = this.$route.query.house_id;

      var param = {
        id: houseid,
        type_id: radioHouseTyped,
        facilities: sheshidstring,
        village_name: xqnamed,
        room: regionRoomd,
        hall: regionTingd,
        bathrooms: regionWeid,
        and: regionYajingd,
        pay: regionZujingd,
        area: this.form.area,
        province: province,
        city: city,
        regional: regional,
        location_address: this.form.location_address,
        longitude: this.form.longitude,
        latitude: this.form.latitude,
        subway: subwayd,
        station: subwaystationd,
        // address: addressd,
        rental: rentd,
        commission: rentbaid,
        building_no: lounumberd,
        room_no: haonumberd,
        imgurl: imgurlend,
        landlord_name: fdname,
        landlord_phone: fdphone,
        user_id: userid,
        introduction: jianjied,
        size: housesized,
        rent_type: rentType,
      };

      https
        .fetchPost("/personal-center/house-save", qs.stringify(param))
        .then((data) => {
          if (data.data.res_code == 0) {
            this.$message.error("发布失败，请重试");
          } else {
            loading.close();
            this.$router.push({ path: "/PersonalCenter" }); //测试
            console.log(data);
          }
        })
        .catch((err) => {
          console.log(err);
        });

      // console.log(this.form.imgurldata);
    },
  },
};
</script>
<style src="../assets/css/bootstrap.min.css" scoped></style>
<style scoped>
.el-col {
  padding: 5px 0px;
}

.re-2copy {
  width: 50%;
  margin-left: -66px;
}

.sdf {
  color: #fff;
}
.el-cascader--medium {
  width: 230px;
}

.re-1 {
  width: 70%;
}

.el-form-item__label {
}

.login-container {
  /* 加载背景图 */

  background-image: url(../assets/images/zhiyeindex.jpg);

  /* 当内容高度大于图片高度时，背景图像的位置相对于viewport固定 */

  background-attachment: fixed;

  /* 让背景图基于容器大小伸缩 */

  background-size: cover;
  position: fixed;
  width: 100%;
  height: 100%;
}

.re-2 {
  width: 50%;
}

.re-12 {
  width: 50%;
}

.re-13 {
  width: 100%;
  text-align: left;
}

.re-14 {
  width: 100%;
  text-align: left;
  margin-left: -68px;
}

.re-11 {
  width: 100%;
}

.re-3 {
  /* display: block; */
}

.re-4 {
  width: 100%;

  /* float: left; */
}

.re-5 {
  width: 100%;

  /* float: left; */
  margin-left: -56px;
}

.re-6 {
  width: 100%;

  margin-left: -112px;
}

.re-7 {
  width: 100%;
}

.re-8 {
  width: 100%;

  margin-left: -56px;
}

.re-9 {
  width: 70%;
}

.re-10 {
  margin-left: -66px;
}
</style>
